module.exports = __webpack_public_path__ + "static/devfestlille2021-0c8fa281ef8762380ab4c75fc0c07045.png";